import { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Blockies from 'react-blockies'
import milligramLogo from '../assets/milligram.svg'
import metamaskLogo from '../assets/metamask.png'
import { loadAccount } from '../store/interactions.js'

const Navbar = ({ onMenuClick, activePage, onPageChange }) => {
  const dispatch = useDispatch()
  const provider = useSelector(state => state.provider.connection)
  const account = useSelector(state => state.provider.account)
  const [mobileNavOpen, setMobileNavOpen] = useState(false)

  const connectHandler = async () => {
    await loadAccount(provider, dispatch)
  }

  const handlePageChange = (page) => {
    onPageChange(page)
    setMobileNavOpen(false)
  }

  return (
    <header className='header'>
      <nav className='navbar'>
        <div className='navbar__left'>
          <img src={milligramLogo} className="navbar__logo" alt="milligram.tv logo" />
        </div>

        {/* Hamburger button — mobile only */}
        <button
          className={`navbar__hamburger${mobileNavOpen ? ' navbar__hamburger--open' : ''}`}
          onClick={() => setMobileNavOpen(!mobileNavOpen)}
          aria-label="Toggle navigation"
        >
          <span />
          <span />
          <span />
        </button>

        <div className={`navbar__center${mobileNavOpen ? ' navbar__center--open' : ''}`}>
          <button className={`navbar__nav-link${activePage === 'dex' ? ' navbar__nav-link--active' : ''}`} onClick={() => handlePageChange('dex')}>DEX</button>
          <button className={`navbar__nav-link${activePage === 'instructions' ? ' navbar__nav-link--active' : ''}`} onClick={() => handlePageChange('instructions')}>Instructions</button>
          <button className={`navbar__nav-link${activePage === 'docs' ? ' navbar__nav-link--active' : ''}`} onClick={() => handlePageChange('docs')}>Docs</button>
          <button className={`navbar__nav-link${activePage === 'about' ? ' navbar__nav-link--active' : ''}`} onClick={() => handlePageChange('about')}>About</button>
          <button className={`navbar__nav-link${activePage === 'contact' ? ' navbar__nav-link--active' : ''}`} onClick={() => handlePageChange('contact')}>Contact</button>
          <button className={`navbar__nav-link${activePage === 'whitepaper' ? ' navbar__nav-link--active' : ''}`} onClick={() => handlePageChange('whitepaper')}>Whitepaper</button>
        </div>

        {/* Backdrop for mobile nav */}
        {mobileNavOpen && <div className="navbar__backdrop" onClick={() => setMobileNavOpen(false)} />}

        <div className='navbar__right'>
          {account ? (
            <button className='navbar__account-btn' onClick={onMenuClick}>
              <Blockies
                seed={account}
                size={8}
                scale={3}
                color="#FFD700"
                bgColor="#F5F0E8"
                spotColor="#B8960C"
                className="identicon"
              />
              {account.slice(0, 5) + '...' + account.slice(38, 42)}
              <svg width="12" height="7" viewBox="0 0 10 6" fill="none">
                <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          ) : (
            <button className='navbar__account-btn navbar__account-btn--desktop' onClick={connectHandler}>
              <img src={metamaskLogo} alt="MetaMask" className="navbar__metamask" />
              Connect
            </button>
          )}
        </div>
      </nav>

      {!account && (
        <div className='navbar__mobile-notice' aria-disabled="true">
          Please log in through desktop
        </div>
      )}
    </header>
  )
}

export default Navbar
